export default IconWebhookOff => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-webhook-off" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4.876 13.61a4 4 0 1 0 6.124 3.39h6" />
  <path d="M15.066 20.502a4 4 0 0 0 4.763 -.675m1.171 -2.827a4 4 0 0 0 -4 -4" />
  <path d="M16 8a4 4 0 0 0 -6.824 -2.833m-1.176 2.833c0 1.506 .77 2.818 2 3.5l-3 5.5" />
  <path d="M3 3l18 18" />
</svg>`;